module.exports = __webpack_public_path__ + "img/ico-button-play.124df09.svg";